export default __webpack_public_path__ + "static/media/signup.6f9722bb.png";